import { Hero, CommunitiesGrid, FinalCTA } from "pages/Main/components";

function Main() {
  return (
    <>
      <Hero />
      <CommunitiesGrid />
      <FinalCTA />
    </>
  );
}

export default Main;
